import api from "@/api";
import i18n from "@/i18n";

const state = {};

const getters = {};

const actions = {
  async getLEDList({ rootState }, query) {
    const res = await api.getLEDList(query);
    let list = res.results ? res.results : [];

    const commentRes = await api.getCommentCount(list.map((item) => item.id));
    commentRes.results = commentRes.results || [];
    list = list.map((item) => {
      const comment = commentRes.results.find(
        (comment) => comment.object_id === item.id
      );
      return comment
        ? {
            comment_count: comment.count,
            ...item,
          }
        : item;
    });

    if (rootState.user.isSignIn) {
      const checkRes = await api.checkLEDLike(list.map((item) => item.id));
      list = list.map((item) => {
        return {
          is_like: checkRes.result[item.id] || item.is_like,
          ...item,
        };
      });
    }
    return {
      ...res,
      results: list,
    };
  },
  async getLEDDraftList({ rootState }, query) {
    const res = await api.getLEDDraftList(query);
    let list = res.results ? res.results : [];

    const commentRes = await api.getCommentCount(list.map((item) => item.id));
    commentRes.results = commentRes.results || [];
    list = list.map((item) => {
      const comment = commentRes.results.find(
        (comment) => comment.object_id === item.id
      );
      return comment
        ? {
            comment_count: comment.count,
            ...item,
          }
        : item;
    });

    if (rootState.user.isSignIn) {
      const checkRes = await api.checkLEDLike(list.map((item) => item.id));
      list = list.map((item) => {
        return {
          is_like: checkRes.result[item.id] || item.is_like,
          ...item,
        };
      });
    }

    return {
      ...res,
      results: list,
    };
  },
  async getLEDLikeList({ rootState }, query) {
    const res = await api.getLEDLike(query);
    let list = res.results ? res.results : [];

    const ledRes = await api.getLEDList({
      ids: list.map((item) => item.led_id),
      page_size: query.page_size,
    });
    ledRes.results = ledRes.results || [];
    list = list.map((item) => {
      const led = ledRes.results.find((led) => led.id === item.led_id);
      return led
        ? {
            ...item,
            ...led,
          }
        : {
            ...item,
            id: item.led_id,
            name: i18n.tc("light.removed"),
            config_text:
              '{"speed":{"index":1,"value":11},"brightness":{"index":2,"value":10},"frames":[{"frameIndex":1,"frameRGB":["#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#000000","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#FFFFFF","#000000","#FFFFFF","#000000","#FFFFFF","#000000","#000000","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#000000","#000000","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#000000","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#FFFFFF","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#000000","#000000","#000000","#000000","#000000","#FFFFFF","#FFFFFF","#FFFFFF","#000000","#FFFFFF"]}]}',
            description: "",
            user_id: "",
          };
    });

    const commentRes = await api.getCommentCount(list.map((item) => item.id));
    commentRes.results = commentRes.results || [];
    list = list.map((item) => {
      const comment = commentRes.results.find(
        (comment) => comment.object_id === item.id
      );
      return comment
        ? {
            comment_count: comment.count,
            ...item,
          }
        : item;
    });

    if (rootState.user.isSignIn) {
      const checkRes = await api.checkLEDLike(list.map((item) => item.id));
      list = list.map((item) => {
        return {
          is_like: checkRes.result[item.id] || item.is_like,
          ...item,
        };
      });
    }
    return {
      ...res,
      results: list,
    };
  },
  async getLED({ rootState }, id) {
    const res = await api.getLED(id);
    let led = res;

    const commentRes = await api.getCommentCount([id]);
    commentRes.results = commentRes.results || [];
    const comment = commentRes.results.find(
      (comment) => comment.object_id === id
    );
    led = {
      ...led,
      comment_count: comment ? comment.count : 0,
    };

    if (rootState.user.isSignIn) {
      const likeRes = await api.checkLEDLike([led.id]);
      led = {
        ...led,
        is_like: likeRes.result[led.id],
      };
    }

    return led;
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
